import SiteNav from "../components/site/SiteNav";
import SiteFooter from "../components/site/SiteFooter";
import Hero from "./landing/Hero";
import { WhySection, FreeSection, HowSection, FounderSection, GroupsSection } from "./landing/Sections";
import { TagsSection, ShopSection, PrivacySection, CtaSection } from "./landing/Showcase";

export default function Landing() {
  return (
    <div className="landing bg-white text-[#16294A] min-h-screen scroll-smooth" style={{ fontFamily: "Sora, sans-serif" }} data-testid="landing-page">
      <SiteNav active="home" />
      <main>
        <Hero />
        <WhySection />
        <FreeSection />
        <HowSection />
        <FounderSection />
        <GroupsSection />
        <TagsSection />
        <ShopSection />
        <PrivacySection />
        <CtaSection />
      </main>
      <SiteFooter />
    </div>
  );
}
